


// get navbtn by id 
export let navbtn = document.getElementById('menuSvg')




